import { render } from "./SourceModalUploadFile.vue?vue&type=template&id=0a84597e&scoped=true"
import script from "./SourceModalUploadFile.vue?vue&type=script&lang=js"
export * from "./SourceModalUploadFile.vue?vue&type=script&lang=js"

import "./SourceModalUploadFile.vue?vue&type=style&index=0&id=0a84597e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a84597e"]])

export default __exports__